import { userClient } from './auth';
// 1:1 문의 내역 조회하기
export async function getInquiries({ pageNumber, pageSize }: { pageNumber: number; pageSize: number }) {
  return await userClient.get(`/inquiries?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}

// 1:1 문의 설정 내역 조회하기
export async function getInquiriesSett() {
  return await userClient.get(`/inquiries/configurations`);
}

// 1:1 문의 등록하기
export async function addInquiries(type: any, title: any, content: any, directEmaill: any, smsCheck: any, url: any) {
  return await userClient.post(`/inquiries`, {
    inquiryTypeNo: type,
    inquiryTitle: title,
    inquiryContent: content,
    uploadedFileName: url,
    originalFileName: url,
    answerSmsSendYn: smsCheck,
    answerEmailSendYn: directEmaill,
  });
}

// 1:1 문의 설정 내역 조회하기
export async function getInquiriesDetail({ inquiryNo }: any) {
  return await userClient.get(`/inquiries/${inquiryNo}`);
}
